"use client";

import Link from "next/link";
import { Panel } from "@/components/ui";
import { useI18n } from "@/components/shell";

export default function HomePage() {
  const { tt } = useI18n();
  const pillars = [
    ["01", "Portal", tt("pillar1")],
    ["02", "Bridge", tt("pillar2")],
    ["03", "Engine", tt("pillar3")],
    ["04", "Venue-ready", tt("pillar4")],
  ];

  return (
    <>
      <section className="grid items-center gap-10 pb-4 pt-4 lg:grid-cols-[1.15fr_0.85fr] lg:pt-6">
        <div>
          <p className="chip border-cyan-700/70 bg-cyan-900/45 text-cyan-200">
            <span className="h-1.5 w-1.5 rounded-full bg-cyan-400" />
            {tt("landingKicker")}
          </p>
          <h1 className="mt-6 max-w-xl text-4xl font-bold leading-[1.1] text-white md:text-5xl">
            {tt("landingTitle")}
            <span className="mt-2 block text-2xl font-semibold text-cyan-400 md:text-3xl">{tt("landingAccent")}</span>
          </h1>
          <p className="mt-6 max-w-lg text-base leading-relaxed text-slate-400 md:text-lg">{tt("landingBody")}</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link href="/register" className="btn-primary px-6 py-2">
              {tt("enterSystem")}
            </Link>
            <Link href="/login" className="btn-ghost px-6 py-2">
              {tt("haveAccount")}
            </Link>
          </div>
        </div>

        <Panel className="overflow-hidden p-0">
          <div className="flex items-center justify-between border-b border-slate-700 px-4 py-3">
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-rose-400/80" />
              <span className="h-2 w-2 rounded-full bg-amber-400/80" />
              <span className="h-2 w-2 rounded-full bg-green-500/80" />
              <span className="ml-2 text-[11px] font-semibold text-slate-400">engine · session</span>
            </div>
            <span className="chip border-cyan-700/70 bg-cyan-900/45 text-cyan-200">LIVE PATH</span>
          </div>
          <div className="space-y-1 p-5 font-mono text-sm leading-[1.7] text-slate-400">
            <div>
              <span className="text-cyan-400">kairos</span>
              <span> @ control-plane</span>
            </div>
            <div>$ connect --alias IC-DEMO --login ****</div>
            <div className="text-green-400">ok  endpoint-2  18ms  failover ready</div>
            <div>$ sync positions</div>
            <div>0 open · equity streamed from MT5</div>
            <div>$ keep-alive --every 25s</div>
            <div className="text-slate-500">master password never leaves the engine</div>
            <div className="pt-2 text-cyan-400">▊</div>
          </div>
        </Panel>
      </section>

      <section className="mt-8 grid gap-4 md:grid-cols-4">
        {pillars.map(([n, title, desc]) => (
          <Panel key={title} className="p-5">
            <div className="font-mono text-xs text-cyan-400">{n}</div>
            <div className="mt-3 text-lg font-bold text-white">{title}</div>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{desc}</p>
          </Panel>
        ))}
      </section>

      <section className="mt-8 grid gap-4 lg:grid-cols-3">
        <Panel className="p-6 lg:col-span-2">
          <h3 className="text-lg font-bold text-white">{tt("liveStack")}</h3>
          <div className="mt-4 grid gap-3 sm:grid-cols-3">
            {[
              ["Web", "Next.js portal"],
              ["Engine", "Python · keep-alive"],
              ["Bridge", "self-hosted mt5rest"],
            ].map(([k, v]) => (
              <div key={k} className="rounded-lg border border-slate-700 bg-slate-900/30 p-4">
                <div className="text-white">{k}</div>
                <div className="mt-1 font-mono text-xs text-slate-400">{v}</div>
              </div>
            ))}
          </div>
        </Panel>
        <Panel className="p-6">
          <h3 className="text-lg font-bold text-white">{tt("nonCustodial")}</h3>
          <p className="mt-4 text-sm leading-relaxed text-slate-400">{tt("nonCustodialBody")}</p>
        </Panel>
      </section>
    </>
  );
}
